import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './DocumentPreviewModal.css';

/** Un documento entero (PDF o imagen) con el visor del navegador, que ya hace el scroll por páginas.
 *  Se trae el fichero original con el token. Con `page` el PDF se abre por esa página. */
export const DocumentFrame = ({ analysisHash, filename, page, className }) => {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let objectUrl = null;
    fetch(`${process.env.REACT_APP_API_URL}/v1/analyses/${analysisHash}/original`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then(res => (res.ok ? res.blob() : Promise.reject(res.status)))
      .then(blob => {
        objectUrl = URL.createObjectURL(blob);
        setUrl({ src: objectUrl, esPdf: blob.type === 'application/pdf' });
      })
      .catch(() => setError('No se ha podido cargar el documento.'));
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [analysisHash]);

  if (error) return <p className="doc-preview-error">{error}</p>;
  if (!url) return <p className="doc-preview-cargando">Cargando el documento…</p>;
  if (!url.esPdf) return <img src={url.src} alt={filename} className={className || 'doc-preview-imagen'} />;
  return <iframe src={page ? `${url.src}#page=${page}` : url.src} title={filename} className={className || 'doc-preview-visor'} />;
};

/** LAKPED-29: previsualizar un documento en un pop-up, sin entrar en el flujo del análisis.
 *  Va en un portal sobre `body` para que el fondo tape también la cabecera. */
const DocumentPreviewModal = ({ analysisHash, filename, onClose }) => {
  useEffect(() => {
    const cerrarConEscape = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', cerrarConEscape);
    return () => window.removeEventListener('keydown', cerrarConEscape);
  }, [onClose]);

  return createPortal(
    <div className="doc-preview" onClick={onClose}>
      <div className="doc-preview-cuerpo" onClick={(e) => e.stopPropagation()}>
        <div className="doc-preview-barra">
          <span className="doc-preview-nombre">{filename}</span>
          <button type="button" className="doc-preview-cerrar" onClick={onClose}>Cerrar</button>
        </div>
        <DocumentFrame analysisHash={analysisHash} filename={filename} />
      </div>
    </div>,
    document.body,
  );
};

export default DocumentPreviewModal;
